<template>
    <div class="row">
        <!-- Selector Tipo de Usuario -->
        <div class="col-md-3 mb-4">
            <div class="card shadow-sm border-0 rounded-lg p-3 bg-white h-100 card-custom-layout">
                <h5 class="d-flex align-items-center mb-4 font-weight-bold text-dark-title">
                    <span class="mr-2 icon-bg text-primary-gradient"><i class="fas fa-user-tag"></i></span>
                    Tipo De Usuario
                </h5>
                <div class="select-container">
                    <tiposgestores-component :placeholderm="'Tipo Usuario'" ref="tipousuario" v-on:cambioTipoGestor="setTipoUsuario"></tiposgestores-component>
                </div>
            </div>
        </div>

        <!-- Tabla de Roles -->
        <div class="col-md-4 mb-4">
            <div class="card shadow-sm border-0 rounded-lg p-3 bg-white h-100 card-custom-layout">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h5 class="d-flex align-items-center m-0 font-weight-bold text-dark-title">
                        <span class="mr-2 icon-bg text-warning-gradient"><i class="fas fa-user-shield"></i></span>
                        Roles del Tipo
                    </h5>
                    <div v-show="!addRol && tipoUsuario !== null">
                        <button type="button" class="btn btn-sm btn-primary-gradient rounded-pill px-3 shadow-sm border-0 d-flex align-items-center" @click="addR">
                            <i class="fa fa-plus mr-1"></i> Agregar
                        </button>
                    </div>
                </div>

                <div class="row px-2 mb-3" v-show="addRol">
                    <div class="col-md-12 p-3 bg-light-gradient rounded-lg border border-light">
                        <div class="form-group mb-3">
                            <label class="font-weight-bold text-muted small">Nombre del Nuevo Rol:</label>
                            <input type="text" maxlength="30" class="form-control form-control-sm rounded-pill px-3 border-muted-custom" placeholder="Ej. Supervisor Moët" v-model="newRol">
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-sm btn-success rounded-pill px-3 mr-2 shadow-sm border-0" @click="addNewRol">
                                <i class="fas fa-save mr-1"></i> Guardar
                            </button>
                            <button type="button" class="btn btn-sm btn-light rounded-pill px-3 shadow-sm" @click="addR">
                                <i class="fas fa-times mr-1"></i> Cancelar
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="!showSelectedRol" class="d-flex flex-column align-items-center justify-content-center my-auto py-5 text-muted empty-state-container">
                    <i class="fas fa-arrow-left fa-2x mb-3 text-muted-light"></i>
                    <span class="small font-weight-semibold">Seleccione un tipo de usuario para ver los roles</span>
                </div>

                <div v-show="showSelectedRol" class="table-responsive custom-table-wrapper">
                    <v-client-table :data="tableRoles" :columns="columns" :options="options">
                        <div slot="Acc" slot-scope="props">
                            <button 
                                type="button" 
                                class="btn btn-sm btn-role-select rounded-circle shadow-sm"
                                :class="{'btn-warning selected-role': selectedRol === props.row.Id, 'btn-light': selectedRol !== props.row.Id}"
                                @click="asignPermiso(props.row.Id,props.row.Rol)"
                                title="Ver Permisos"
                            >
                                <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                    </v-client-table>
                </div>
            </div>
        </div>

        <!-- Permisos -->
        <div class="col-md-5 mb-4">
            <div class="card shadow-sm border-0 rounded-lg p-3 bg-white h-100 card-custom-layout">
                <h5 class="d-flex align-items-center mb-4 font-weight-bold text-dark-title">
                    <span class="mr-2 icon-bg text-success-gradient"><i class="fas fa-mobile-alt"></i></span>
                    Permisos en Aplicación
                </h5>

                <div v-if="!showSelectedPermision" class="unselected-state my-auto">
                    <div class="lock-icon-container mb-3">
                        <i class="fas fa-lock text-muted"></i>
                    </div>
                    <h6 class="font-weight-bold text-dark">Asignación de Accesos Móviles</h6>
                    <p class="text-muted-light small px-4">Seleccione un rol de la lista para gestionar sus permisos y accesos en la aplicación móvil.</p>
                </div>

                <div v-else class="h-100 d-flex flex-column">
                    <div class="panel-header mb-3">
                        <div class="d-flex flex-column">
                            <span class="panel-header-label">Configurando accesos para:</span>
                            <div class="role-title-badge mt-1"><i class="fas fa-shield-alt mr-1"></i> {{ Rol }}</div>
                        </div>
                    </div>

                    <div class="permissions-grid">
                        <div 
                            v-for="(p, index) in mappedPermisos" 
                            :key="p.cveper"
                            class="permission-card"
                            :class="{ 'active': p.status === 1 }"
                            @click="togglePermission(p)"
                        >
                            <div class="permission-icon-container" :style="{ backgroundColor: p.status === 1 ? p.color : '#f8fafc', color: p.status === 1 ? '#ffffff' : '#64748b' }">
                                <i :class="[p.icon, 'permission-icon']"></i>
                            </div>
                            <div class="permission-info">
                                <span class="permission-name">{{ p.name }}</span>
                                <span class="permission-status-text" :style="{ color: p.status === 1 ? '#10b981' : '#94a3b8' }">
                                    {{ p.status === 1 ? 'Habilitado' : 'Deshabilitado' }}
                                </span>
                            </div>
                            <div class="permission-toggle">
                                <span class="custom-switch" :class="{ 'switch-on': p.status === 1 }"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const PERMISSIONS_METADATA = [
        { cveper: 1, name: 'Reporte Encuestas', icon: 'fas fa-highlighter', color: '#4f46e5' },
        { cveper: 2, name: 'Reporte Faltantes', icon: 'fas fa-box-open', color: '#ef4444' },
        { cveper: 3, name: 'Reporte Promociones', icon: 'fas fa-air-freshener', color: '#f59e0b' },
        { cveper: 4, name: 'Reporte Anaquel', icon: 'fas fa-align-justify', color: '#06b6d4' },
        { cveper: 5, name: 'Reporte Exhibiciones', icon: 'fas fa-sort-amount-up-alt', color: '#10b981' },
        { cveper: 6, name: 'Reporte Precios', icon: 'fas fa-money-check-alt', color: '#84cc16' },
        { cveper: 7, name: 'Reporte Gráfico', icon: 'fas fa-camera-retro', color: '#ec4899' },
        { cveper: 8, name: 'Comentario', icon: 'far fa-comments', color: '#8b5cf6' },
        { cveper: 9, name: 'Captura Rápida', icon: 'fas fa-arrows-alt-h', color: '#f97316' },
        { cveper: 10, name: 'Reporte Mercadeo', icon: 'fas fa-store-alt', color: '#0ea5e9' },
        { cveper: 11, name: 'Reporte Campañas', icon: 'fas fa-swatchbook', color: '#14b8a6' },
        { cveper: 12, name: 'Reporte Inventario', icon: 'fas fa-truck-loading', color: '#0284c7' },
        { cveper: 13, name: 'Reporte Ventas', icon: 'fas fa-file-invoice-dollar', color: '#64748b' }
    ];

    export default {
        name: "UsuariosPermisosAplicacion",
        data(){
            return{
                permisos:[],
                addRol:false,
                newRol:'',
                columns: ['Id', 'Rol','Acc'],
                tableTipos: [],
                tableRoles: [],
                options: {
                    footerHeadings: false,
                    filterable: false,
                    filterByColumn: false,
                    perPage: 10,
                    perPageValues: [10, 20, 40],
                    headings: {
                        Id: 'ID',
                        Rol: 'Rol',
                        Acc: 'Acción',
                    },
                    columnsClasses: {
                        Id: 'text-center align-middle',
                        Rol: 'text-left align-middle font-weight-semibold',
                        Acc: 'text-center align-middle',
                    },
                    texts: {
                        count: "Mostrando {from} al {to} de {count} registros",
                        first: 'Primero',
                        last: 'Último',
                        filter: "Buscar:",
                        filterPlaceholder: "Buscar...",
                        limit: "Registros:",
                        page: "Página:",
                        noResults: "No hay resultados disponibles",
                        loading: 'Cargando...',
                    },
                },
                selectedRol:null,
                Rol:'',
                tipoUsuario:null,
                showSelectedRol:false,
                showSelectedPermision:false,
            }
        },
        computed: {
            mappedPermisos() {
                if (!this.permisos || this.permisos.length === 0) return [];
                return PERMISSIONS_METADATA.map(meta => {
                    const permission = this.permisos.find(p => p.Cveper === meta.cveper);
                    return {
                        ...meta,
                        id: permission ? permission.Id : null,
                        status: permission ? parseInt(permission.Status) : 0,
                        raw: permission
                    };
                });
            }
        },
        mounted() {
            this.getData();
        },
        methods:{
            getRolesUsers(){
                let $this = this;
                axios.post('/api/AdminCatalogos/getRolesUsers',{tipouser:this.tipoUsuario})
                    .then(r => {
                            if (r.data.Success){
                                $this.tableRoles = r.data.Data;
                                $this.showSelectedRol = true;
                            }
                        })
                    .catch(error => {
                        console.error("Error al obtener roles:", error);
                    });
            },
            setTipoUsuario(){
                let $this = this;
                this.tableRoles = [];
                var a = this.$refs.tipousuario.selectedTiposGestores;
                if(a !== null){
                    this.tipoUsuario = a.value;
                    this.showSelectedPermision = false;
                    axios.post('/api/AdminCatalogos/getRolesUsers',{tipouser:this.tipoUsuario})
                        .then(r => {
                                if (r.data.Success){
                                    $this.tableRoles = r.data.Data;
                                    $this.showSelectedRol = true;
                                }
                            })
                        .catch(error => {
                            console.error("Error al obtener roles:", error);
                        });
                }
                else{
                    this.showSelectedRol = false;
                    this.showSelectedPermision = false;
                    this.tipoUsuario = null;
                }
            },
            getData(){
                let $this = this;
                this.tableTipos = [];
                axios.post('/api/AdminCatalogos/getTpoUsers',{})
                    .then(r => {
                        if (r.data.Success){
                            $this.tableTipos = r.data.Data;
                        }
                    })
                    .catch(error => {
                        console.error("Error al obtener tipos de usuario:", error);
                    });
            },
            addR(){
                this.newRol = '';
                this.addRol = !this.addRol;
            },
            addNewRol(){
                if (!this.newRol.trim()) {
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'Campo requerido',
                        text: 'Por favor ingrese un nombre para el nuevo rol'
                    });
                    return;
                }
                let $this = this;
                axios.post('/api/AdminCatalogos/addNewRol',{
                    rol:this.newRol,tipousuario:this.tipoUsuario
                })
                    .then(r => {
                        if (r.data.Success){
                            $this.$swal.fire({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 3000,
                                timerProgressBar: true,
                                icon: 'success',
                                title: r.data.Mensaje
                            });
                            $this.getRolesUsers();
                            $this.newRol = '';
                            $this.addRol = false;
                        }
                    })
                    .catch(error => {
                        console.error("Error al registrar rol:", error);
                    });
            },
            asignPermiso(id,name){
                let $this = this;
                this.permisos = [];
                axios.post('/api/AdminCatalogos/getPermisosApk',{
                    id:id,tipousuario:this.tipoUsuario
                })
                    .then(r => {
                            if (r.data.Success){
                                $this.permisos = r.data.Permisos;
                                $this.selectedRol = id;
                                $this.Rol = name;
                                $this.showSelectedPermision = true;
                            }
                        })
                    .catch(error => {
                        console.error("Error al obtener permisos:", error);
                    });
            },
            togglePermission(p) {
                const newstatus = p.status === 1 ? 0 : 1;
                let $this = this;
                axios.post('/api/AdminCatalogos/changePermisoApk',{
                    id: p.id, status: newstatus
                })
                .then(r => {
                        if (r.data.Success){
                            $this.$swal.fire({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 2000,
                                timerProgressBar: true,
                                icon: 'success',
                                title: r.data.Mensaje
                            });
                            if (p.raw) {
                                p.raw.Status = newstatus;
                            } else {
                                const perm = $this.permisos.find(item => item.Id === p.id);
                                if (perm) {
                                    perm.Status = newstatus;
                                }
                            }
                        }
                    })
                .catch(error => {
                    console.error("Error al cambiar permiso:", error);
                });
            }
        }
    }
</script>

<style scoped>
    /* Card customizations */
    .card-custom-layout {
        transition: all 0.3s ease;
        border-radius: 16px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    .text-dark-title {
        color: #1e293b;
        font-size: 16px;
        letter-spacing: -0.2px;
    }

    /* Icon badge background */
    .icon-bg {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    .text-primary-gradient {
        background: rgba(79, 70, 229, 0.1);
        color: #4f46e5;
    }

    .text-warning-gradient {
        background: rgba(245, 158, 11, 0.1);
        color: #f59e0b;
    }

    .text-success-gradient {
        background: rgba(16, 185, 129, 0.1);
        color: #10b981;
    }

    /* Buttons with gradients */
    .btn-primary-gradient {
        background: linear-gradient(135deg, #4f46e5, #6366f1);
        color: white;
        transition: all 0.2s ease;
    }

    .btn-primary-gradient:hover {
        background: linear-gradient(135deg, #4338ca, #4f46e5);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(79, 70, 229, 0.2) !important;
    }

    /* Light alert box */
    .bg-light-gradient {
        background: #f8fafc;
        border: 1px solid #f1f5f9 !important;
    }

    .border-muted-custom {
        border-color: #cbd5e1;
        transition: border-color 0.2s ease;
    }

    .border-muted-custom:focus {
        border-color: #4f46e5;
        box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
    }

    /* Role selections inside client table */
    .btn-role-select {
        width: 30px;
        height: 30px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
    }

    .btn-role-select:hover {
        transform: scale(1.1);
    }

    .selected-role {
        background-color: #f59e0b !important;
        border-color: #f59e0b !important;
        color: white !important;
        box-shadow: 0 4px 10px rgba(245, 158, 11, 0.3) !important;
    }

    /* Custom Table styling overrides */
    .custom-table-wrapper ::v-deep .VueTables__search-field {
        margin-bottom: 15px;
    }

    .custom-table-wrapper ::v-deep .VueTables__search-field input {
        border-radius: 50px !important;
        padding: 6px 16px !important;
        border: 1px solid #e2e8f0 !important;
        font-size: 13px !important;
        outline: none !important;
    }

    .custom-table-wrapper ::v-deep .VueTables__search-field input:focus {
        border-color: #4f46e5 !important;
        box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1) !important;
    }

    .custom-table-wrapper ::v-deep table {
        border-collapse: separate !important;
        border-spacing: 0 6px !important;
        width: 100% !important;
    }

    .custom-table-wrapper ::v-deep table tbody tr {
        background-color: #f8fafc !important;
        transition: all 0.2s ease;
    }

    .custom-table-wrapper ::v-deep table tbody tr:hover {
        background-color: #f1f5f9 !important;
        transform: translateY(-1px);
    }

    .custom-table-wrapper ::v-deep table td {
        border: none !important;
        padding: 10px 14px !important;
    }

    .custom-table-wrapper ::v-deep table th {
        border: none !important;
        font-size: 11px !important;
        font-weight: 700 !important;
        color: #94a3b8 !important;
        text-transform: uppercase !important;
        padding: 8px 14px !important;
    }

    .custom-table-wrapper ::v-deep table tbody tr td:first-child {
        border-top-left-radius: 10px !important;
        border-bottom-left-radius: 10px !important;
    }

    .custom-table-wrapper ::v-deep table tbody tr td:last-child {
        border-top-right-radius: 10px !important;
        border-bottom-right-radius: 10px !important;
    }

    .custom-table-wrapper ::v-deep .VuePagination {
        margin-top: 15px !important;
        display: flex !important;
        justify-content: center !important;
    }

    .custom-table-wrapper ::v-deep .pagination {
        display: flex !important;
        padding-left: 0 !important;
        list-style: none !important;
        border-radius: 50px !important;
    }

    .custom-table-wrapper ::v-deep .page-item.active .page-link {
        background-color: #4f46e5 !important;
        border-color: #4f46e5 !important;
        color: #ffffff !important;
    }

    .custom-table-wrapper ::v-deep .page-link {
        padding: 6px 12px !important;
        font-size: 12px !important;
        color: #4f46e5 !important;
        border: 1px solid #e2e8f0 !important;
    }

    /* Unselected Empty State styling */
    .unselected-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        text-align: center;
        border: 2px dashed #f1f5f9;
        border-radius: 12px;
        background: #fafafa;
        min-height: 240px;
    }

    .lock-icon-container {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: rgba(148, 163, 184, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
    }

    .text-muted-light {
        color: #94a3b8 !important;
    }

    /* Permissions Section Layout */
    .panel-header {
        background: linear-gradient(135deg, #1e293b, #0f172a);
        color: #ffffff;
        padding: 16px 20px;
        border-radius: 12px;
        box-shadow: 0 4px 15px rgba(15, 23, 42, 0.1);
    }

    .panel-header-label {
        font-size: 11px;
        color: #94a3b8;
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 0.5px;
    }

    .role-title-badge {
        background: rgba(245, 158, 11, 0.15);
        color: #fbbf24;
        padding: 4px 12px;
        border-radius: 20px;
        font-weight: 700;
        font-size: 13px;
        display: inline-block;
        border: 1px solid rgba(245, 158, 11, 0.2);
    }

    .permissions-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        gap: 12px;
        max-height: 480px;
        overflow-y: auto;
        padding-right: 4px;
    }

    /* Scrollbar Styling for permissions grid */
    .permissions-grid::-webkit-scrollbar {
        width: 6px;
    }
    .permissions-grid::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 10px;
    }
    .permissions-grid::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 10px;
    }
    .permissions-grid::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }

    /* Permission Card Styling */
    .permission-card {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        user-select: none;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }

    .permission-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
        border-color: #cbd5e1;
    }

    .permission-card.active {
        border-color: rgba(16, 185, 129, 0.25);
        background: rgba(16, 185, 129, 0.03);
    }

    .permission-icon-container {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        transition: all 0.2s ease;
        flex-shrink: 0;
    }

    .permission-icon {
        font-size: 15px;
    }

    .permission-info {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        margin-right: 8px;
        overflow: hidden;
    }

    .permission-name {
        font-size: 12px;
        font-weight: 700;
        color: #1e293b;
        line-height: 1.25;
    }

    .permission-status-text {
        font-size: 10px;
        font-weight: 500;
        margin-top: 2px;
    }

    .permission-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    /* CSS Switch Toggle styling */
    .custom-switch {
        width: 32px;
        height: 18px;
        background-color: #e2e8f0;
        border-radius: 100px;
        position: relative;
        transition: background-color 0.2s ease;
        display: inline-block;
    }

    .custom-switch::after {
        content: '';
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #ffffff;
        top: 2px;
        left: 2px;
        transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 1px 2px rgba(0,0,0,0.15);
    }

    .switch-on {
        background-color: #10b981 !important;
    }

    .switch-on::after {
        transform: translateX(14px);
    }

    /* Helper typography styles */
    .font-weight-semibold {
        font-weight: 600 !important;
    }
    .empty-state-container {
        border: 2px dashed #f1f5f9;
        border-radius: 12px;
        background: #fafafa;
    }
</style>
